import { useCallback } from 'react';

import { betActions, BetType, Logger, roundNumber, useBetSlice, useChipSlice, useGameStateSlice } from '@pp/core';

import { BetIds } from '../../../config/bets';
import { useGameDispatch } from '../../../store/GameStore';
import { GameInstantBetsSender } from '../../../controllers/gameCommunication/senders/GameInstantBetSender';
const senders = new GameInstantBetsSender();

export const useBetOnAllCallbackConnected = (): (() => void) => {
  const dispatch = useGameDispatch();
  const isBetsOpenStatus = useGameStateSlice.isBetsOpenStatus();
  const selectedChip = useChipSlice.getSelectedChip();
  const totalBet = useBetSlice.totalBet();
  const balance = useGameStateSlice.getDeductibleBalance();
  const decimals = useGameStateSlice.getCurrencyInfo()?.digitsNumber || 2;

  const bets = useBetSlice.bets();
  const betLimits = useBetSlice.betLimits();

  // Should not be blocked by min limit, as bet may be placed many times

  return useCallback(() => {
    const selectedChipValue = selectedChip.value;
    if (!selectedChip || !isBetsOpenStatus) {
      return;
    }

    let amount = balance;
    const betSpots: BetType = { betSpots: {} };

    BetIds.forEach((betSpot) => {
      let valueToBet = selectedChipValue;

      let blockedByLimit = false;
      if (betLimits) {
        const currentSpotBet = bets?.betSpots[betSpot]?.value ?? 0;

        if (betLimits[betSpot]?.max) {
          const betLimit = betLimits[betSpot]?.max || Infinity;
          const amountTillLimit = roundNumber(betLimit - currentSpotBet, decimals);

          valueToBet = Math.min(valueToBet, amountTillLimit);
          blockedByLimit = currentSpotBet >= betLimit;
        }
      }
      if (amount >= roundNumber(valueToBet + totalBet, decimals) && !blockedByLimit) {
        amount = roundNumber(amount - valueToBet, decimals);
        betSpots.betSpots[betSpot] = { value: valueToBet };
      }
    });

    if (Object.keys(betSpots.betSpots).length > 0) {
      dispatch(betActions.pushBet({ bet: betSpots, balance, decimals }));
      senders.dispatch('');
      Logger.logEvent('click', 'betOnAll', Date.now(), 1, '', false);
    }
  }, [balance, betLimits, bets?.betSpots, decimals, dispatch, isBetsOpenStatus, selectedChip, totalBet]);
};
